/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExternalCostDtoFromJSON, ExternalCostDtoToJSON, } from './ExternalCostDto';
import { RevenueMonthYearDtoFromJSON, RevenueMonthYearDtoToJSON, } from './RevenueMonthYearDto';
/**
 * Check if a given object implements the SavePastDataForProject interface.
 */
export function instanceOfSavePastDataForProject(value) {
    return true;
}
export function SavePastDataForProjectFromJSON(json) {
    return SavePastDataForProjectFromJSONTyped(json, false);
}
export function SavePastDataForProjectFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'otherCosts': json['otherCosts'] == null ? undefined : (json['otherCosts'].map(ExternalCostDtoFromJSON)),
        'ricavi': json['ricavi'] == null ? undefined : (json['ricavi'].map(RevenueMonthYearDtoFromJSON)),
        'noteCostiRicavi': json['noteCostiRicavi'] == null ? undefined : json['noteCostiRicavi'],
    };
}
export function SavePastDataForProjectToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'otherCosts': value['otherCosts'] == null ? undefined : (value['otherCosts'].map(ExternalCostDtoToJSON)),
        'ricavi': value['ricavi'] == null ? undefined : (value['ricavi'].map(RevenueMonthYearDtoToJSON)),
        'noteCostiRicavi': value['noteCostiRicavi'],
    };
}
